import { EmptyState } from "@/components/page-layout";
import { Button } from "@/components/ui/Button";
import { ToolsetsGraphic } from "../toolsets/ToolsetsEmptyState";

export function PromptsEmptyState({
  onCreatePrompt,
}: {
  onCreatePrompt: () => void;
}): JSX.Element {
  const cta = (
    <Button size="sm" onClick={onCreatePrompt}>
      CREATE A PROMPT
    </Button>
  );

  return (
    <EmptyState
      heading="No prompts yet"
      description="The platform's prompt builder allows you to easily create and distribute reusable MCP prompts to your users."
      nonEmptyProjectCTA={cta}
      graphic={<ToolsetsGraphic />}
      graphicClassName="scale-90"
    />
  );
}
